import React, { Component, PropTypes } from 'react';

class Check extends Component {
  constructor() {
    super();
  }

  render() {
    return (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="3329.675 124.675 8.55 6.35">
					<g id="Group_50" transform="translate(2997 -31)">
						<g id="Group_48">
							<path id="Path_45" style="fill: #c1d64d;" d="M335,161.8l-2.1-2.1a.636.636,0,1,1,.9-.9l2.1,2.1a.636.636,0,1,1-.9.9Z"/>
						</g>
						<g id="Group_49"> 
							<path id="Path_46"style="fill: #c1d64d;" d="M341,156.8l-5,5a.636.636,0,1,1-.9-.9l5-5a.636.636,0,0,1,.9.9Z"/>
						</g>
					</g>
				</svg>
    );
  }
}

Check.propTypes = {
};

export default Check;



/** WEBPACK FOOTER **
 ** ./src/icons/Check/index.js
 **/